import $ from 'jquery'
import { updateQueryStringParameter } from './../../shared/url'

/**
 * "All Results Page" functionality.
 */
export default function showAllResults () {
  const $container = $('.js-search')

  const $toggleButton = $('.js-toggle-all-results', $container)
  const $tableHeader = $('.js-search-table-header', $container)
  const $results = $('.js-search-results', $container)
  const $controls = $('.js-search-controls', $container)
  const $pagination = $('.js-search-pagination', $container)

  const toggleClass = $container.data('all-results-css-class')
  const allResultsURLParam = 'all-results'

  /**
   * On load.
   */
  function main () {
    /**
     * On "All Results" button click.
     */
    $toggleButton.on('click', onButtonToggle)

    /**
     * Check if the All Results Page is requested on Page Load.
     */
    checkIfAllResultsPageOnLoad()

    /**
     * Go to a scene when the browser's Back button is pressed.
     * @param {object} event The event
     */
    window.onpopstate = function onBackButtonPress () {
      activateRelevantSearchPage()
    }
  }

  /**
   * "All Results" toggling event.
   */
  function onButtonToggle () {
    activateAllResultsPage()
    updateURL()
  }

  /**
   * Shows and hides the corresponding elements of the "All Results Search" layout.
   */
  function activateAllResultsPage () {
    $container.addClass(toggleClass)
    $controls.css('display', 'flex')

    if (window.innerWidth >= 992 && !$results.is(':empty')) {
      $tableHeader.css('display', 'flex')
    }
  }

  /**
   * Shows and hides the corresponding elements of the "Relevant Search" layout.
   */
  function activateRelevantSearchPage () {
    $container.removeClass(toggleClass)
    $tableHeader.hide()
    $controls.hide()
    $pagination.hide()
  }

  /**
   * Add the "all results" query param to the URL.
   */
  function updateURL () {
    let newURL = `${window.location.href}&${allResultsURLParam}=1`

    if (window.location.href.indexOf(allResultsURLParam) !== -1) {
      newURL = updateQueryStringParameter(window.location.href, allResultsURLParam, 1)
    }

    window.history.pushState('', '', newURL)
  }

  /**
   * Checks is the "all results" query param is in the URL.
   */
  function checkIfAllResultsPageOnLoad () {
    const pathArray = window.location.href.split(allResultsURLParam)

    if (pathArray && pathArray[1] === '=1') {
      activateAllResultsPage()
    }
  }

  main()
}
